// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

function getEnvValue(key, defaultValue) {
  const browserWindow = window || {};
  const browserWindowEnv = browserWindow['__env'] || {};
  if (browserWindowEnv.hasOwnProperty(key)) {
    // console.log(key + '' '' + window['__env'][key]);
    return window['__env'][key];
  } else {
    // console.log(key + '' DV '' + defaultValue);
    return defaultValue;
  }
}

export const environment = {
  production: getEnvValue('controlBaseUrl', false),
  controlBaseUrl: getEnvValue('controlBaseUrl', 'http://localhost:9082'),
  controlWebSocketUrl: getEnvValue('controlWebSocketUrl', 'ws://localhost:9082/socket'),
  dynamicApiUrlSandbox: getEnvValue('dynamicApiUrlSandbox', 'http://localhost:9993/api'),
  dynamicApiUrlProduction: getEnvValue('dynamicApiUrlProduction', 'http://localhost:9993/api'),
  flowManagerBaseUri: '/api',
  flowManagerBaseUriV2: '/api/v2',
  flowsUri: 'flows',
  flowUri: 'flow',
  routeUri: 'route',
  channelsUri: 'channels',
  endpointUri: 'endpoint',
  endpointsUri: 'endpoints',
  managementBaseUri: '/management',
  submissionUri: 'submission',
  submissionBaseUri: '/submissions',
  emulatorUrl: 'http://na/ussd/emulator/dial',
  redirectUri: getEnvValue('redirectUri', 'http://localhost:4200'),
  requireHttps: true,
  clientId: 'flow-manager-ui-local',
  issuer: getEnvValue('issuer', 'https://fail/'),
  scope: 'openid offline',
  allowedUrls: getEnvValue('allowedUrls', ['http://localhost:9082']),
  postLogoutRedirectUri: getEnvValue('postLogoutRedirectUri', 'http://localhost:4200'),

  // DATADOG CONFIG
  datadog: getEnvValue('datadogEnabled', false),
  datadog_applicationId: getEnvValue('datadogApplicationId', 'fail'),
  datadog_clientToken: getEnvValue('datadogClientToken', 'fail'),
  datadog_site: 'datadoghq.com',
  datadog_env: getEnvValue('datadogEnv', 'dev'),

  googleApiKey: getEnvValue('googleApiKey', 'AIzaSyA0vwLFnbrr_Wn5mo2DqcnEjeMhE25n1vc'),
};
